import { call, put } from "redux-saga/effects";
import { createAutoConfig, deleteAutoConfig, getAutoConfig, updateAutoConfig } from "../../../../Services/apiService";
import { createAutoConfigFailure, createAutoConfigSuccess, deleteAutoConfigFailure, deleteAutoConfigSuccess, getAutoConfigFailure, getAutoConfigSuccess, updateAutoConfigFailure, updateAutoConfigSuccess } from "../../../Slices/autoConfigSlice";

export function* getAutoConfigHandler(actions) {
    try {
        const response = yield call(getAutoConfig, actions?.payload);
        yield put(getAutoConfigSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getAutoConfigFailure(errResponse))
    }
}

export function* createAutoConfigHandler(actions) {
    try {
        const response = yield call(createAutoConfig, actions?.payload);
        yield put(createAutoConfigSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createAutoConfigFailure(errResponse))
    }
}

export function* updateAutoConfigHandler(actions) {
    try {
        const response = yield call(updateAutoConfig, actions?.payload);
        yield put(updateAutoConfigSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updateAutoConfigFailure(errResponse))
    }
}

export function* deleteAutoConfigHandler(actions) {
    try {
        const response = yield call(deleteAutoConfig, actions?.payload);
        yield put(deleteAutoConfigSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(deleteAutoConfigFailure(errResponse))
    }
}